(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/intro-settings/assets/javascripts/intro-settings.js') >= 0) return;  svs.modules.push('/components/components/intro-settings/assets/javascripts/intro-settings.js'); 
(function(svs) {
  'use strict';

  svs.components.IntroSettings = (function() {
    var storageDomain = 'svs.components.intro-settings';

    function get(id) {
      var currentStatus = svs.components.Storage.browser.get(id, storageDomain);
      return currentStatus === undefined && !svs.core.data.capabilities.isRobot ?
        true :
        currentStatus;
    }

    function set(id, display) {
      svs.components.Storage.browser.set(
        id,
        storageDomain,
        display,
        svs.components.Storage.constants.EXPIRES_1YEAR
      );
    }

    function toggle(id) {
      var newStatus = !this.get(id);
      this.set(id, newStatus);
      return newStatus;
    }

    return {
      get: get,
      set: set,
      toggle: toggle
    };
  })();
})(svs);

 })(window);